// src/components/shell/navConfig.js
// Source unique des entrées de navigation du nouveau shell.
// On garde EXACTEMENT les mêmes routes/outils qu'avant, on ne change que l'habillage.
import {
  MessageSquare,
  Cpu,
  PlayCircle,
  Trophy,
  BookOpenText,
  SendHorizonal,
  Repeat2,
  TrendingUp,
  Info,
  Globe2,
  LineChart,
  Sprout,
} from "lucide-react";

// Libellés FR / EN (indépendants de l'ancienne Sidebar).
export const SHELL_LABELS = {
  fr: {
    sectionMain: "Outils",
    sectionSystem: "Système",
    search: "Rechercher un outil…",
    chat: "Chat IA",
    agent: "Agent IA",
    backtest: "Backtest",
    challenge: "Challenge",
    journalAuto: "Journal Auto",
    execution: "Exécution",
    copyTrading: "Copy Trading",
    strategies: "Stratégies",
    marketAnalysis: "Analyse fondamentale",
    riskGarden: "Risque Garden",
    soon: "Bientôt disponible",
    fullmargin: "FullMargin",
    help: "Aide",
    account: "Mon compte",
    settings: "Paramètres",
    logout: "Déconnexion",
    upgrade: "Passer Pro",
    language: "Langue",
    themeLight: "Mode clair",
    themeDark: "Mode sombre",
    notifications: "Notifications",
    agenda: "Agenda",
    theme: "Thème",
    expandSidebar: "Déplier la barre",
  },
  en: {
    sectionMain: "Tools",
    sectionSystem: "System",
    search: "Search a tool…",
    chat: "AI Chat",
    agent: "AI Agent",
    backtest: "Backtest",
    challenge: "Challenge",
    journalAuto: "Auto Journal",
    execution: "Execution",
    copyTrading: "Copy Trading",
    strategies: "Strategies",
    marketAnalysis: "Fundamental analysis",
    riskGarden: "Risk Garden",
    soon: "Coming soon",
    fullmargin: "FullMargin",
    help: "Help",
    account: "My account",
    settings: "Settings",
    logout: "Log out",
    upgrade: "Go Pro",
    language: "Language",
    themeLight: "Light mode",
    themeDark: "Dark mode",
    notifications: "Notifications",
    agenda: "Calendar",
    theme: "Theme",
    expandSidebar: "Expand sidebar",
  },
};

// Outils principaux (mêmes routes qu'avant).
export const MAIN_NAV = [
  { to: "/", labelKey: "chat", icon: MessageSquare, end: true },
  { to: "/agent", labelKey: "agent", icon: Cpu },
  { to: "/journal-auto", labelKey: "journalAuto", icon: BookOpenText },
  { to: "/execution", labelKey: "execution", icon: SendHorizonal },
  { to: "/copy-trading", labelKey: "copyTrading", icon: Repeat2 },
  { to: "/challenge", labelKey: "challenge", icon: Trophy },
  { to: "/strategies", labelKey: "strategies", icon: TrendingUp },
  { to: "/backtest", labelKey: "backtest", icon: PlayCircle },
  { to: "/market-analysis", labelKey: "marketAnalysis", icon: LineChart },
  // soon: true → entrée non cliquable, badge « Bientôt disponible ».
  { labelKey: "riskGarden", icon: Sprout, soon: true },
];

// Entrées système (bas de sidebar).
export const SYSTEM_NAV = [
  // logo: true → la sidebar affiche le logo FullMargin au lieu d'une icône.
  { external: true, href: "https://fullmargin.net", labelKey: "fullmargin", icon: Globe2, logo: true },
  { to: "/help", labelKey: "help", icon: Info },
];

export function pickLang() {
  try {
    const l = (localStorage.getItem("i18nextLng") || navigator.language || "fr").toLowerCase();
    return l.startsWith("en") ? "en" : "fr";
  } catch {
    return "fr";
  }
}

// Titre affiché dans la barre du haut (mobile), déduit de la route courante.
// /account et /settings ne sont plus des pages : le compte se gère sur
// FullMargin, thème et langue sont dans le menu du haut.
const EXTRA_TITLES = [];

export function titleForPath(pathname, t) {
  const hit = [...MAIN_NAV, ...SYSTEM_NAV, ...EXTRA_TITLES].find(
    (i) => i.to && (i.end ? pathname === i.to : pathname.startsWith(i.to))
  );
  return hit ? t[hit.labelKey] || hit.labelKey : "FullMetrix";
}
